/**
 * 共通設定を読み込み
 * 計測する前に必ず呼ぶ想定
 */
export const setCommonMetrics = () => {
    s.prop57 = savedJobsCount();
    s.prop71 = 'PC';
}

/***
 * お気に入り登録件数を計測用に取得
 * @return {number}
 */
const savedJobsCount = () => {
    const savedJobJson = localStorage.getItem('saved_jobs');
    const savedJobs = JSON.parse(savedJobJson);
    if (!savedJobs || savedJobs.length === 0) {
        return 0;
    } else {
        return savedJobs.length;
    }
}
